import script from "./engine.vue?vue&type=script&setup=true&lang=js"
export * from "./engine.vue?vue&type=script&setup=true&lang=js"

import "./engine.vue?vue&type=style&index=0&id=4de3ab06&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de3ab06"]])

export default __exports__